import { ModelTableView } from '@/assets/js/ModelView'
import * as C from '../list'

const person = new ModelTableView([
	C.name,
	C.handle,
	C.phone,
	C.email,
	C.webUrl,
	C.trackerUrl,
	C.remarks,
	C.state
]);

person.visibleProperties([ "name", "handle", "phone", "email", "webUrl", "trackerUrl" ]);
person.sortBy("name");

export default person;



// WEBPACK FOOTER //
// ./src/services/components/views/person.js